import type Pageable from 'models/Pageable';
import type { AnchorPartnerVO, AnchorPartnerVOModel } from 'models/vo/AnchorPartnerVO';
import { formattingToAnchorPartnerVOModel } from 'models/vo/AnchorPartnerVO';
import http from 'utils/http';
import API_SY from 'utils/http/api/system';

import type { SystemAnchorPartnerListRequest } from './requests';

export async function requestSystemAnchorPartnerList(
  pageNumber: number,
  rowCount: number,
  data: SystemAnchorPartnerListRequest,
): Promise<Pageable<AnchorPartnerVOModel[]>> {
  const response = await http.get<Pageable<AnchorPartnerVO[]>>({
    url: API_SY.ANCHOR_PARTNERS.ANCHOR_PARTNER_LIST,
    data: {
      pageNumber,
      rowCount,
      ...data,
    },
  });

  return {
    ...response,
    content: response.content.map(data => formattingToAnchorPartnerVOModel(data)),
  };
}

export async function requestSystemAnchorPartnerData(anchorPartnerId: number): Promise<AnchorPartnerVOModel> {
  const response = await http.get<AnchorPartnerVO>({
    url: API_SY.ANCHOR_PARTNERS.ANCHOR_PARTNER_DETAIL(anchorPartnerId),
  });

  return formattingToAnchorPartnerVOModel(response);
}
